<template>
  <div>
    <Form :model="mysearchData" inline>
      <span v-for="(item, index) in searchList" :key="item.flag + index">
        <FormItem label="">
          <!-- 账户名称 -->
          <Input
            v-if="item.type == 'input'"
            search
            v-model="mysearchData[item.prop]"
            :placeholder="item.name"
            @on-search="
              item.change && item.change(item, mysearchData[item.prop])
            "
          />
          <Button
            v-if="item.type == 'button'"
            :disabled="addBtnDisabled"
            type="primary"
            @click="item.handle(item)"
            >{{ item.name }}</Button
          >
        </FormItem>
      </span>
    </Form>
    <Table
      :columns="columns"
      :data="tableData"
      style="margin-bottom:10px"
      :loading="listLoading"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <Button type="error" size="small" @click="$emit('handleDel', row)">{{
          $t("alarms.common.delete")
        }}</Button>
      </template>
    </Table>
    <Page
      :current="mysearchData.pageNum"
      :total="mysearchData.total"
      show-sizer
      :page-size="mysearchData.pageSize"
      @on-change="handleChangePageNum"
      @on-page-size-change="handleChangePageSize"
      :transfer="true"
    ></Page>
  </div>
</template>

<script>
import { getCookie } from "../../../../../utils/cookieUtil";

export default {
  props: {
    searchData: {
      type: Object,
      default: () => {}
    },
    searchList: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    addBtnDisabled: {
      type: Boolean,
      default: true
    },
    listLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // mysearchData: { ...this.searchData, ...this.searchList }, // 链接两个对象
      mysearchData: this.searchData, // 链接两个对象
      modalLoading: false,
      isDisable: false,
      dataTotal: 0
    };
  },
  methods: {
    handleChangePageSize(data) {
      this.$emit("changePageSize", data);
    },
    handleChangePageNum(data) {
      this.$emit("changePageNum", data);
    }
  },
  mounted() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/resource/ResourceIndex.vue